var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedbackBtn_box",on:{"click":_vm.goFeedback}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip_box"},[_c('span',{staticClass:"tip_text"},[_vm._v("反馈")])])
}]

export { render, staticRenderFns }